import {
  Box,
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React from 'react';
import { hot } from 'react-hot-loader/root';

type Props = {
  open: boolean;
  title: string;
  content: string;
  platforms: string[];
  closeModal();
  onSave();
};

const SharedRoleConfirmationModal: React.FC<Props> = ({
  open,
  title,
  content,
  platforms,
  closeModal,
  onSave,
}) => {
  return (
    <Modal
      open={open}
      size="small"
      onClose={closeModal}
      data-testid="confirmation-modal"
    >
      <Box>
        <ModalTitle onClose={closeModal} data-testid="confirmation-header">
          {title}
        </ModalTitle>
      </Box>
      <ModalContent>
        <Typography variant="body1" data-testid="confirmation-body-header">
          {content}
        </Typography>

        <ul>
          {platforms.map((platform) => (
            <li key={platform}>
              <Typography variant="body1" data-testid={`list-item-${platform}`}>
                {platform}
              </Typography>
            </li>
          ))}
        </ul>
      </ModalContent>
      <ModalActions>
        <Button
          onClick={closeModal}
          color="primary"
          variant="text"
          data-testid="cancel-confirmation-modal"
        >
          {`Don't save`}
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          data-testid="confirm-confirmation-modal"
        >
          Save changes
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default hot(React.memo(SharedRoleConfirmationModal));
